"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlphabetBasedNumberConverter = void 0;
var tslib_1 = require("tslib");
var ordinal_based_number_converter_1 = require("./ordinal-based-number-converter");
var AlphabetBasedNumberConverter = (function (_super) {
    tslib_1.__extends(AlphabetBasedNumberConverter, _super);
    function AlphabetBasedNumberConverter(alphabet) {
        var _this = _super.call(this) || this;
        _this.minValue = 0;
        _this.maxValue = 780;
        _this.alphabet = alphabet;
        return _this;
    }
    AlphabetBasedNumberConverter.prototype.convertNumberCore = function (value) {
        if (value == 0)
            return "";
        value--;
        var alphabetSize = this.alphabet.length;
        var count = Math.floor(value / alphabetSize + 1);
        var symbol = this.alphabet[value % alphabetSize];
        return Array(count + 1).join(symbol);
    };
    return AlphabetBasedNumberConverter;
}(ordinal_based_number_converter_1.OrdinalBasedNumberConverter));
exports.AlphabetBasedNumberConverter = AlphabetBasedNumberConverter;
